const urlQueryParts = (data) => {
  if (!data) return '';

  return Object.entries(data).length
    ? `/?${Object.entries(data)
        .filter(([prop, val]) => prop && val !== undefined && val !== null)
        .map(([prop, val]) => (Array.isArray(val) ? val : [val])
          .map(value => `${encodeURIComponent(prop)}=${encodeURIComponent(value)}`).join('&'))
        .join('&')}`
    : '';
};

export default urlQueryParts;
